import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';

export const getWhitelabelConfigs = async ({ rootState, state, dispatch, commit }) => {
  let response = await dispatch('get', rootState.currentUser._links.get_whitelabel_domains.href);

  commit('updateState', { object: state, property: 'domains', value: response.data });

  return response;
};

export const saveWhitelabelConfig = async ({ state, dispatch, commit }) => {
  let payload = cloneDeep(state.currentDomain.config);

  let response = await dispatch('put', { apiUrl: state.currentDomain._links.update_domain_config.href, payload });

  response = await dispatch('get', response.whitelabel_site_settings);

  commit('updateCurrentDomain', response.data.config);

  response = dispatch('saveWhitelabelAssets');

  return response;
};

export const saveWhitelabelAssets = async ({ state, dispatch, commit }) => {
  let response,
    isUploadingAnAsset = false;

  if (state.logoImage) {
    isUploadingAnAsset = true;

    response = await dispatch('post', { apiUrl: state.currentDomain._links.upload_whitelabel_logo.href, payload: { wl_logo_image_data_uri: state.logoImage } });
  }

  if (state.faviconImage) {
    isUploadingAnAsset = true;

    response = await dispatch('post', { apiUrl: state.currentDomain._links.upload_whitelabel_favicon.href, payload: { wl_favicon_image_data_uri: state.faviconImage } });
  }

  if (state.bannerImage) {
    isUploadingAnAsset = true;

    response = await dispatch('post', { apiUrl: state.currentDomain._links.upload_whitelabel_banner.href, payload: { wl_banner_image_data_uri: state.bannerImage } });
  }

  if (isUploadingAnAsset) {
    commit('updateCurrentDomain', {});

    response = await dispatch('get', response.whitelabel_site_settings);

    commit('updateCurrentDomain', response.data.config);
  }

  return response;
};

export const verifyDns = async ({ dispatch }, domain) => {
  return dispatch('get', `${hateoas.url('whitelabel_verify_dns', { clientId: storage.get('client-hash') })}?domain=${domain}`);
};

export const createWhitelabelConfig = async ({ state, dispatch, commit }) => {
  let payload = cloneDeep(state.currentDomain.config);

  if (payload.assets.banner.startsWith('data:image')) {
    payload.assets.banner = '';
  }

  if (payload.assets.favicon.startsWith('data:image')) {
    payload.assets.favicon = '';
  }

  if (payload.assets.logo.startsWith('data:image')) {
    payload.assets.logo = '';
  }

  let response = await dispatch('post', { apiUrl: hateoas.url('client_create_whitelabel_site', { clientId: storage.get('client-hash') }), payload });

  response = await dispatch('get', response.whitelabel_site);

  commit('updateState', { object: state, property: 'currentDomain', value: response.data });

  try {
    await dispatch('saveWhitelabelAssets');
  } catch (e) {
    commit('addNotification', 'Your domain was created but one or more of your asset(s) encountered an error and subsequently was not saved properly. Please correct the specified errors and try saving again.');
  }

  await dispatch('getCurrentUserId', true);

  await dispatch('getWhitelabelConfigs');

  return response;
};

export const activateDomain = async ({ dispatch, commit }, domain) => {
  let response;

  try {
    response = await dispatch('patch', { apiUrl: domain._links.make_active.href });

    commit('addNotification', response.data.message);

    response = await dispatch('getWhitelabelConfigs');
  } catch (e) {}

  return response;
};

export const deactivateDomain = async ({ dispatch }, domain) => {
  let response;

  try {
    response = await dispatch('patch', {
      apiUrl: domain._links.deactivate.href,
      payload: {
        note: 'Deactivated manually from client admin.',
      }
    });

    response = await dispatch('getWhitelabelConfigs');
  } catch (e) {}

  return response;
};